import { ReactNode } from 'react'

import * as SC from './styles'

type Props = {
  children: ReactNode
}

export const SidePanelFooter = (props: Props) => {
  const { children } = props

  return <SC.Footer>{children}</SC.Footer>
}
